import {UI, styleRuleCustom, styleRuleInherit, styleRule} from "../../stem-core/src/ui/UI";
import {App} from "../App";
import {GlobalStyleSheet} from "../GlobalStyleSheet";
import {Route, Router} from "../../stem-core/src/ui/Router";
import {iFrameConnection} from "../services/IFrameConnection";
import {IFrameMessages} from "../../blink-sdk/messaging/IFrameMessages";
import {iFrameState} from "../services/IFrameState";
import {
    LOGIN_WITH_EMAIL_CODE_URL,
    SIGNUP_EXTERNAL_URL,
    AUTH_MODAL_CLOSE_TIMEOUT
} from "../Constants";
import {authService, userService} from "../../client/connection/Services";

import {Theme} from "../../stem-core/src/ui/UI";
import {unwrapArray} from "../../stem-core/src/base/Utils";
import {PageTitleManager} from "../../stem-core/src/base/PageTitleManager";
import {
    FUNCTIONALITY_NOT_ENABLED_URL,
    INLINE_DONATION_URLS,
    INLINE_EDIT_DONATION_URLS,
    INLINE_EDIT_SUBSCRIPTION_URLS, INLINE_GIFT_SUBSCRIPTION_URLS,
    INLINE_NEWSLETTER_URLS,
    INLINE_SUBSCRIPTION_URLS, INLINE_USER_DASHBOARD_URLS
} from "./PaywallConstants";
import {AuthSuccessSpinner} from "../website/unauthenticated/components/AuthSuccessSpinner";
import {BlinkGlobal, isDeepEqual, isSafari, isSmallScreen, setToastClass} from "../Utils";

import {Errors} from "../../client/connection/services/Errors";
import {
    AUTHENTICATION_PANEL_TYPE, EMPTY_PANEL_TYPE,
    GATE_TYPE,
    IFRAME_APP_TYPE,
    PANEL_TYPE,
    PANEL_VARIANT,
    POPUP_GATE_TRANSITION_TIME,
    SOCIAL_APPS
}
    from "../../blink-sdk/Constants";
import {AuthorizationPanel} from "./pages/AuthorizeApplication";
import {AuthHelper} from "../AuthHelper";
import {Image} from "../../stem-core/src/ui/UIPrimitives";
import {LoadingSpinner} from "../ui/LoadingSpinner";
import {supportsPassiveEvents} from "../../blink-sdk/utils/Utils";
import {DonateHomePage} from "./donate-page/DonateHomePage";
import {collapseIframe, collapseIframeAndExpandWallet} from "../widget/misc/WidgetUtils";
import {iFrameMerchantService} from "../services/IframeMerchantService";
import {iFrameUserDataService} from "../services/IFrameUserDataService";
import {AuthenticationPanel} from "./pages/panels/AuthenticationPanel";
import {DonationAuthenticationPanel} from "./pages/panels/donation/DonationAuthenticationPanel";
import {EmailCodeConfirmationPanel} from "./pages/panels/EmailCodeConfirmationPanel";
import {DonatePanel} from "./pages/panels/donation/DonatePanel";
import {PaymentMethodPanel} from "./pages/panels/payment-method/PaymentMethodPanel";
import {DonationFailedPanel} from "./pages/panels/donation/DonationFailedPanel";
import {DonationSuccessPanel} from "./pages/panels/donation/DonationSuccessPanel";
import {EditDonationPanel} from "./pages/panels/donation/edit-donation/EditDonationPanel";
import {CancelDonationPanel} from "./pages/panels/donation/edit-donation/CancelDonationPanel";
import {DonationCanceledPanel} from "./pages/panels/donation/edit-donation/DonationCanceledPanel";
import {EditDonationSuccessPanel} from "./pages/panels/donation/edit-donation/EditDonationSuccessPanel";
import {SubscribePlanPanel} from "./pages/panels/subscribe/SubscribePlanPanel";
import {SubscribeAuthenticationPanel} from "./pages/panels/subscribe/SubscribeAuthenticationPanel";
import {SubscribeReviewOrderPanel} from "./pages/panels/subscribe/SubscribeReviewOrderPanel";
import {SubscribeThankYouPanel} from "./pages/panels/subscribe/SubscribeThankYouPanel";
import {SubscribeFailedPanel} from "./pages/panels/subscribe/SubscribeFailedPanel";
import {donateMobileState} from "./inline-donation/DonateMobileState";
import {EditSubscriptionPanel} from "./pages/panels/subscribe/edit-subscription/EditSubscriptionPanel";
import {EditSubscriptionCancelPanel} from "./pages/panels/subscribe/edit-subscription/EditSubscriptionCancelPanel";
import {EditSubscriptionCancelSuccessPanel} from "./pages/panels/subscribe/edit-subscription/EditSubscriptionCancelSuccessPanel";
import {EditSubscriptionSuccessPanel} from "./pages/panels/subscribe/edit-subscription/EditSubscriptionSuccessPanel";
import {CustomPanel} from "./pages/panels/CustomPanel";
import {AutopayThresholdExceededPanel} from "./pages/panels/payment/AutopayThresholdExceededPanel";
import {AutopayDisabledPanel} from "./pages/panels/payment/AutopayDisabledPanel";
import {InsufficientFundsPanel} from "./pages/panels/payment/InsufficientFundsPanel";
import {UnexpectedErrorPanel} from "./pages/panels/payment/UnexpectedErrorPanel";
import {PaymentAndDonationPanel} from "./pages/panels/donation/PaymentAndDonationPanel";
import {addThemeConstants} from "../StyleConstants";
import {CDSAuthenticationPanel} from "blinkpay/paywall/inline-subscription/auth/CDSAuthenticationPanel";
import {subscribeFlowState} from "./inline-subscription/SubscribeFlowState";
import {NewsletterPanel} from "./pages/panels/newsletter/NewsletterPanel";
import {NewsletterSubscribePanel} from "./pages/panels/newsletter/NewsletterSubscribePanel";
import {NewsletterSubscribeSuccessPanel} from "./pages/panels/newsletter/NewsletterSubscribeSuccessPanel";
import {InlineUserDashboard} from "./pages/inline-user-dashboard/InlineUserDashboard";
import {InlineUserDashboardRemoveCardPanel} from "./pages/inline-user-dashboard/prompt-panels/InlineUserDashboardRemoveCardPanel";
import {InlineUserDashboardCardInUsagePanel} from "./pages/inline-user-dashboard/prompt-panels/InlineUserDashboardCardInUsagePanel";
import {InlineUserDashboardChangeEmailCodeConfirmPanel} from "./pages/inline-user-dashboard/prompt-panels/InlineUserDashboardChangeEmailCodeConfirmPanel";
import {AddressPanel} from "./pages/panels/address/AddressPanel";
import {InlineUserDashboardRemoveAddressPanel} from "./pages/inline-user-dashboard/prompt-panels/InlineUserDashboardRemoveAddressPanel";
import {InlineUserDashboardAddressInUsePanel} from "./pages/inline-user-dashboard/prompt-panels/InlineUserDashboardAddressInUsePanel";
import {subscribePlanController} from "./inline-subscription/SubscribePlanController";
import {InlineUserDashboardSubscriptionChangeConfirmPanel} from "./pages/inline-user-dashboard/prompt-panels/InlineUserDashboardSubscriptionChangeConfirmPanel";
import {englishTranslationMap} from "../Messages";
import {apiConnection} from "../../client/connection/BlinkApiConnection";
import {GlobalState} from "../../stem-core/src/state/State";
import {iFrameAuthService, shiftToMerchantToken} from "../services/IFrameAuthService";
import {InlineUserDashboardSubscribeChangeSuccessPanel} from "./pages/inline-user-dashboard/prompt-panels/InlineUserDashboardSubscribeChangeSuccessPanel";
import {MerchantAudienceStore} from "../../client/state/merchant/MerchantAudienceStore";
import {FunctionalityNotEnabledPanel} from "./pages/panels/FunctionalityNotEnabledPanel";
import {PaywallToast} from "./PaywallToast";
import {ensureNaClScript} from "../../client/crypto/encryptJSON";
import {BasePanel} from "./pages/panels/BasePanel";
import {merchantStyleRule} from "./Security";
import {PanelCollapsed} from "./pages/panels/PanelCollapsed";
import {Dispatcher} from "../../stem-core/src/base/Dispatcher";
import {queueMicrotaskWrapper} from "../AsyncAggregateDispatcher";
import {addScrimListeners} from "../widget/WidgetAnimation";
import {PaywallCloseButton} from "./PaywallCloseButton";
import {Device} from "../../stem-core/src/base/Device";
import {GiftSubscriptionPlansPanel} from "./pages/panels/subscribe/gift-subscriptions/GiftSubscriptionPlansPanel";
import {GiftSubscriptionPanel} from "./pages/panels/subscribe/gift-subscriptions/GiftSubscriptionPanel";
import {giftSubscriptionFlowState} from "./inline-subscription/GiftSubscriptionFlowState";
import {GiftSubscriptionReviewOrderPanel} from "./pages/panels/subscribe/gift-subscriptions/GiftSubscriptionReviewOrderPanel";
import {GiftSubscriptionSuccessPanel} from "./pages/panels/subscribe/gift-subscriptions/GiftSubscriptionSuccessPanel";
import {GiftSubscriptionFailedPanel} from "./pages/panels/subscribe/gift-subscriptions/GiftSubscriptionFailedPanel";
import {AnalyticsEventType, dispatchAnalyticsEvent} from "../../blink-sdk/utils/AnalyticsClient";


const popupTop = (Device.isMobileDevice() && isSafari() && window.screen?.availHeight) ?
    Math.max(window.screen?.availHeight / 2 - 100, 0) : "50%";

export class PaywallAppGlobalStyleSheet extends GlobalStyleSheet {
    default19 = {};

    @styleRuleCustom({selector: "body"})
    body = {
        margin: 0,
        userSelect: "text",
        height: "100%",
        width: "100%",
        fontFamily: this.themeProps.MERCHANT_FONT_FAMILY,
        " *": {
            userSelect: () => isSmallScreen() ? "none" : "auto",
            "-webkit-tap-highlight-color": "transparent",
        },
        ">div:nth-child(3)": {
            height: "100%",
        },
        ">div:nth-child(3)>:first-child": {
            minHeight: "100% !important",
            height: "100% !important",
        },
        position: "absolute",
        overflow: "hidden",
        // These are for Safari border bugs during animations.
        "-webkit-backface-visibility": "hidden",
        "-moz-backface-visibility": "hidden",
        "-webkit-transform": "translate3d(0, 0, 0)",
        "-moz-transform": "translate3d(0, 0, 0)",
        color: this.themeProps.MERCHANT_TEXT_PRIMARY_COLOR,
        fontSize: this.themeProps.MERCHANT_FONT_SIZE_NORMAL,
        lineHeight: this.themeProps.GENERAL_LINE_HEIGHT,
    };

    @styleRuleCustom({selector: "body>div>div>div"})
    default5Child = {
        overflow: "hidden !important",
    };

    @styleRuleInherit
    html = {
        overflow: "hidden !important",
    };

    @styleRuleInherit
    a = {
        fontWeight: this.themeProps.MERCHANT_FONT_WEIGHT_BOLD,
    };

    @styleRule
    paywallApp = {
        color: this.themeProps.MERCHANT_TEXT_PRIMARY_COLOR,
        overflow: "hidden !important",
        fontSize: this.themeProps.MERCHANT_FONT_SIZE_NORMAL,
        fontFamily: this.themeProps.MERCHANT_FONT_FAMILY,
        lineHeight: this.themeProps.GENERAL_LINE_HEIGHT,
        borderRadius: this.themeProps.MERCHANT_FRAME_BORDER_RADIUS,
        background: "transparent",
    };

    @merchantStyleRule
    popupGate = {
        opacity: 1,
        boxSizing: "content-box",
        position: "fixed",
        top: popupTop,
        left: "50%",
        transform: "translate(-50%, -50%)",
        margin: "auto",
        zIndex: 10500,
        overflow: "hidden",
        transition: POPUP_GATE_TRANSITION_TIME + "ms ease",
        transitionProperty: "width, height, transform",
        borderRadius: this.themeProps.MERCHANT_FRAME_BORDER_RADIUS,
        ...iFrameState.gateStyle,
    };

    @merchantStyleRule
    popupGateCustom = {
        ...iFrameState.customGateStyle,
        ">:first-child>:last-child": {
            ...iFrameState.cancelButtonCustomStyle,
            " g": {
                fill: iFrameState.cancelButtonCustomStyle?.color || "",
            }
        }
    };

    @styleRuleCustom({selector: "b"})
    b = {
        fontWeight: this.themeProps.MERCHANT_FONT_WEIGHT_BOLD,
    };

    @styleRuleInherit
    allInputs = {
        fontFamily: this.themeProps.MERCHANT_FONT_FAMILY,
    };

    @styleRule
    transitionContainer = {
        pointerEvents: "none",
    };
}

export class PaywallApp extends App {
    isAuthorizationPage = false;
    merchantFonts = [];
    sizeStyle = {};

    extraNodeAttributes(attr) {
        super.extraNodeAttributes(attr);
        const styleSheet = PaywallAppGlobalStyleSheet.getInstance();

        attr.addClass(styleSheet.paywallApp);

        if (iFrameState.gateType === GATE_TYPE.popup) {
            attr.addClass(styleSheet.popupGate);
        }
        if (this.router?.getActive() instanceof BasePanel) {
            attr.addClass(styleSheet.popupGateCustom);
        }
        attr.setStyle(this.sizeStyle);
    }

    applyMerchantTheme() {
        this.addMerchantFonts();
        addThemeConstants(iFrameState.theme);
    }

    applyMerchantMessages() {
        for (const [key, value] of Object.entries(iFrameState.messages)) {
            englishTranslationMap.set(key, value);
        }
    }

    constructor(...args) {
        super(...args);

        BlinkGlobal.appInstance = this;
        this.sizeChange = new Dispatcher();
        this.sizeChange.addListener(({height, width}) => {
            this.sizeStyle = {height, width};
            if (this.node) {
                this.setStyle(this.sizeStyle);
            }
        });

        setToastClass(PaywallToast);
        this.initializeFlows();
        const page = this.getPage();
        this.setupAuthHelper(page);
        this.initRouter(page);

        this.applyMerchantTheme();
        this.applyMerchantMessages();
    }

    getPage() {
        if ((iFrameState.panelType === PANEL_TYPE.donation && !iFrameMerchantService.getMerchant().allowDonations)
            || (iFrameState.panelType === PANEL_TYPE.subscribe && !iFrameMerchantService.getMerchant().allowSubscriptions)
            || (iFrameState.panelType === PANEL_TYPE.newsletter && !iFrameMerchantService.getMerchant().allowEmailing)) {
            return FUNCTIONALITY_NOT_ENABLED_URL;
        }

        const variant = iFrameState.variant;

        if (iFrameState.isInlineDonationFlow()) {
            if (variant === PANEL_VARIANT.editRecurring) {
                return INLINE_EDIT_DONATION_URLS.donate;
            }
            if (variant === PANEL_VARIANT.skipCTA) {
                if (authService.isAuthenticated()) {
                    return INLINE_DONATION_URLS.donate;
                }
                return SIGNUP_EXTERNAL_URL;
            }
            return PANEL_TYPE.donation;
        }

        if (iFrameState.isInlineSubscriptionFlow()) {
            if (variant === PANEL_VARIANT.editRecurring) {
                return INLINE_EDIT_SUBSCRIPTION_URLS.subscribe;
            }
            if (variant === PANEL_VARIANT.skipCTA) {
                return SIGNUP_EXTERNAL_URL;
            }
            return INLINE_SUBSCRIPTION_URLS.subscriptionsOverview;
        }

        if (iFrameState.panelType === PANEL_TYPE.newsletter && variant === PANEL_VARIANT.skipCTA) {
            return INLINE_NEWSLETTER_URLS.subscribe;
        }

        if (iFrameState.panelType === PANEL_TYPE.dashboard && !authService.isAuthenticated()) {
            return SIGNUP_EXTERNAL_URL;
        }

        if (iFrameState.panelType === PANEL_TYPE.giftSubscription) {
            if (variant === PANEL_VARIANT.skipCTA) {
                return SIGNUP_EXTERNAL_URL;
            }
            return INLINE_GIFT_SUBSCRIPTION_URLS.subscriptionPlans;
        }

        return iFrameState.panelType;
    }

    initRouter(initialPage) {
        // The router in this app shouldn't alter the browser history.
        Router.useLocalHistory = true;
        Router.localHistory = ["/" + initialPage];

        let timeout = null;
        let timeoutFunc = null;

        const updateAppStyle = page => {
            if (iFrameState.gateType === GATE_TYPE.popup) {
                const styleSheet = PaywallAppGlobalStyleSheet.getInstance();
                if (page instanceof BasePanel) {
                    this.addClass(styleSheet.popupGateCustom);
                } else {
                    this.removeClass(styleSheet.popupGateCustom);
                }
            }
        }

        Router.prototype.setURL = function(urlParts) {
            AuthSuccessSpinner.hide();
            urlParts = unwrapArray(urlParts);
            const page = this.getPageToRender(urlParts);

            if (!page) return;

            if (timeout && timeoutFunc) {
                clearTimeout(timeout);
                timeoutFunc();
            }

            const activePage = this.getActive();
            const app = BlinkGlobal.appInstance;

            const dispatchRoute = urlParts => {
                if (iFrameState.gateType === GATE_TYPE.popup) {
                    dispatchAnalyticsEvent(AnalyticsEventType.POPUP_PAGE_CHANGE,
                        {page: urlParts.join("/")});
                }
                iFrameConnection.sendToSDK(IFrameMessages.ROUTE_CHANGE, {route: urlParts.join("/")});
            };

            if (page instanceof PanelCollapsed) {
                app.setStyle("pointerEvents", "none");
            } else {
                app.setStyle("pointerEvents", "initial");
            }
            if (app.closeButton) {
                app.closeButton.setStyle(app.getCloseButtonStyle(urlParts.join("/")));
            }

            if (activePage !== page) {
                if (activePage) {
                    activePage.dispatch("urlExit");
                    if (page instanceof PanelCollapsed) {
                        activePage.applyHiddenStyle(activePage); // I would just redraw but at this point this page might have the controller data cleared already,
                    }
                    page.preRender(app.transitionContainer.node);
                    timeoutFunc = () => {
                        page.cancelPreRender();
                        this.setActive(page);
                        dispatchRoute(urlParts)
                        timeout = null;
                        timeoutFunc = null;
                    };
                    timeout = this.attachTimeout(timeoutFunc, POPUP_GATE_TRANSITION_TIME);
                } else {
                    queueMicrotaskWrapper(() => {
                        page.preRender(app.transitionContainer.node);
                        page.cancelPreRender();
                        this.setActive(page);
                        page.dispatch("urlEnter");
                        dispatchRoute(urlParts);
                    });
                }
            } else {
                page.dispatch("urlReload");
            }

            // When you use blinkaction, this first route gets received in the wallet module when the flow is already
            // active and the actual route is the donation one. It seems like the user exited the flow but it's not
            // the case.

            if (page && page.pageTitle) {
                PageTitleManager.setTitle(page.pageTitle);
            }

            this.dispatch("change", urlParts, page, activePage);
            updateAppStyle(page);
        }
    }

    getCloseButtonStyle(path) {
        return path === "/" + EMPTY_PANEL_TYPE ? {
            opacity: 0,
            pointerEvents: "none",
            cursor: "initial",
        } : {
            opacity: 1,
            pointerEvents: "initial",
            cursor: "pointer",
        };
    }

    addMerchantFonts() {
        const styleElement = document.createElement("style");
        for (const font of iFrameState.fonts) {
            if (!this.merchantFonts.find(f => isDeepEqual(f, font))) {
                const {family, style, src, weight, unicodeRange} = font;
                styleElement.appendChild(document.createTextNode(`
                @font-face{
                    font-family: ${family};
                    src: ${src};
                    ${style ? `font-style: ${style};` : ""}
                    ${weight ? `font-weight: ${weight};` : ""}
                    ${unicodeRange ? `unicode-range: ${unicodeRange}; ` : ""}
                }`));
                this.merchantFonts.push(font);
            }
        }
        if (styleElement.innerHTML.length) {
            document.head.appendChild(styleElement);
        }
    }

    static initializeGlobalStyle() {
        PaywallAppGlobalStyleSheet.initialize();
    }

    static addWsListener(streamName) {
        apiConnection.addWsListener(streamName, async event => {
            if (event.type === "logout") {
                if (iFrameAuthService.merchantToken) {
                    shiftToMerchantToken();
                } else {
                    authService.clearCurrentInfo();
                }
            } else {
                GlobalState.applyEvent(event);
            }
        });
    }

    getContainer() {
        return [
            <div>
                <div ref="transitionContainer" className={PaywallAppGlobalStyleSheet.getInstance().transitionContainer}/>
                {this.getRouter()}
                {this.getStaticInvisibleElements()}
                {iFrameState.gateType === GATE_TYPE.popup ?
                    <PaywallCloseButton testId={"modalCloseButton"} style={this.getCloseButtonStyle(Router.getCurrentPath())} ref="closeButton"/> : <span/>}
            </div>,
        ];
    }

    // Render these invisible elements so the fetches execute earlier.
    getStaticInvisibleElements() {
        const merchant = iFrameMerchantService.getMerchant();

        // This is so that the elements are under no circumstance visible.
        return (
            <div style={{opacity: "0", pointerEvents: "none", zIndex: -1, position: "absolute", top: -1e4, left: -1e4}}>
                {merchant ? <Image src={merchant.wideLogoUrl}/> : null}
                <div style={{fontStyle: "italic"}}>a</div>
                <div style={{fontWeight: Theme.props.MERCHANT_FONT_WEIGHT_BOLD}}>a</div>
                <div>a</div>
            </div>
        );
    }

    getSubroutes() {
        // TODO: Try to move as many of these components to their own routes and discriminate
        //  by variant/authentication status in getPage() where possible.
        const getAuthPage = (...args) => {
            if (iFrameState.authSocialProviders.indexOf(SOCIAL_APPS.CDS) !== -1) {
                return new CDSAuthenticationPanel(...args);
            }
            if (iFrameState.isInlineDonationFlow()) {
                return new DonationAuthenticationPanel(...args);
            }
            if (iFrameState.isInlineSubscriptionFlow()) {
                return new SubscribeAuthenticationPanel(...args);
            }

            return new AuthenticationPanel(...args);
        };

        const authBeforeEnter = () => {
            if (this.isAuthorizationPage) {
                return;
            }
            if (iFrameState.isInlineDonationFlow()) {
                AuthHelper.addAuthenticationCallback(() => {
                    LoadingSpinner.show();
                    userService.ensureUserDataRequested(() => {
                        LoadingSpinner.hide();
                        if (iFrameUserDataService.getActiveRecurringDonation()) {
                            collapseIframeAndExpandWallet();
                        } else {
                            Router.changeURL(INLINE_DONATION_URLS.donate);
                        }
                    });
                });
                return;
            }
            if (iFrameState.isInlineSubscriptionFlow()) {
                AuthHelper.addAuthenticationCallback(() => {
                    LoadingSpinner.show();
                    userService.ensureUserDataRequested(() => {
                        LoadingSpinner.hide();
                        if (iFrameUserDataService.getActiveSubscription()) {
                            collapseIframeAndExpandWallet();
                        } else {
                            subscribePlanController.onSelectSuccess();
                        }
                    });
                });
                return;
            }
            if (iFrameState.panelType === PANEL_TYPE.giftSubscription) {
                AuthHelper.addAuthenticationCallback(() => {
                    LoadingSpinner.show();
                    userService.ensureUserDataRequested(() => {
                        LoadingSpinner.hide();
                        subscribePlanController.onSelectSuccess();
                    });
                });
                return;
            }
            if (iFrameState.panelType === PANEL_TYPE.dashboard) {
                AuthHelper.addAuthenticationCallback(() => {
                    LoadingSpinner.show();
                    userService.ensureUserDataRequested(() => {
                        LoadingSpinner.hide();
                        Router.changeURL(PANEL_TYPE.dashboard);
                    });
                });
                return;
            }
            if (authService.isAuthenticated()) {
                setTimeout(collapseIframe, AUTH_MODAL_CLOSE_TIMEOUT);
            }
            AuthHelper.addAuthenticationCallback(() => {
                LoadingSpinner.show();
                setTimeout(collapseIframe, AUTH_MODAL_CLOSE_TIMEOUT);
            });
        };

        const getDonatePage = (...args) => {
            if (donateMobileState.shouldRenderDonatePage()) {
                return new DonatePanel(...args);
            }
            return new PaymentAndDonationPanel(...args);
        };

        const getNewsletterPage = (...args) => {
            if (iFrameUserDataService.isUserSubscribedToAllGivenNewsletters()) {
                return new NewsletterSubscribeSuccessPanel(...args);
            }
            if (MerchantAudienceStore.all().length === 1) {
                return new NewsletterSubscribePanel(...args);
            }
            return new NewsletterPanel(...args);
        };

        const ensureNaClScriptForCDSPaymentPanel = () => {
            if (iFrameMerchantService.isCDSPaymentMethod()) {
                ensureNaClScript();
            }
        };
        const paymentMethodPanelOptions = {
            doNotCache: true,
            beforeEnter: ensureNaClScriptForCDSPaymentPanel,
        };
        const buildRoute = (route, pageClass, options={doNotCache: true}) =>
            new Route([route], pageClass, [], options);

        return [
            buildRoute(SIGNUP_EXTERNAL_URL, getAuthPage, {beforeEnter: authBeforeEnter, doNotCache: true}),
            buildRoute(LOGIN_WITH_EMAIL_CODE_URL, EmailCodeConfirmationPanel),
            buildRoute(Errors.errorLinks.INSUFFICIENT_FUNDS, InsufficientFundsPanel),
            buildRoute(Errors.errorLinks.AUTO_PAY_DISABLED, AutopayDisabledPanel),
            buildRoute(Errors.errorLinks.AUTO_PAY_THRESHOLD_EXCEEDED, AutopayThresholdExceededPanel),
            buildRoute(Errors.errorLinks.UNEXPECTED_ERROR, UnexpectedErrorPanel),
            buildRoute(AUTHENTICATION_PANEL_TYPE, getAuthPage, {beforeEnter: authBeforeEnter, doNotCache: true}),
            buildRoute(FUNCTIONALITY_NOT_ENABLED_URL, FunctionalityNotEnabledPanel),
            buildRoute(PANEL_TYPE.donationPage, DonateHomePage),
            buildRoute(PANEL_TYPE.donation, BasePanel),
            buildRoute(PANEL_TYPE.subscribe, BasePanel),
            buildRoute(PANEL_TYPE.payment, BasePanel),
            buildRoute(PANEL_TYPE.newsletter, getNewsletterPage),
            buildRoute(PANEL_TYPE.identity, AuthorizationPanel,{
                beforeEnter: () => {
                    if (!authService.isAuthenticated()) {
                        this.isAuthorizationPage = true;
                        AuthHelper.addAuthenticationCallback(() => {
                            Router.changeURL(PANEL_TYPE.identity);
                        });
                        return [SIGNUP_EXTERNAL_URL];
                    }
                    return null;
                },
                doNotCache: true,
            }),
            buildRoute(PANEL_TYPE.custom, CustomPanel),
            buildRoute(PANEL_TYPE.dashboard, InlineUserDashboard),
            buildRoute(PANEL_TYPE.giftSubscription, GiftSubscriptionPanel),
            buildRoute(EMPTY_PANEL_TYPE, PanelCollapsed),
            buildRoute(INLINE_NEWSLETTER_URLS.subscribe, NewsletterSubscribePanel),
            buildRoute(INLINE_NEWSLETTER_URLS.success, NewsletterSubscribeSuccessPanel),
            buildRoute(INLINE_DONATION_URLS.donate, getDonatePage),
            buildRoute(INLINE_DONATION_URLS.card, PaymentMethodPanel, paymentMethodPanelOptions),
            buildRoute(INLINE_DONATION_URLS.address, AddressPanel),
            buildRoute(INLINE_DONATION_URLS.thankYou, DonationSuccessPanel),
            buildRoute(INLINE_DONATION_URLS.failed, DonationFailedPanel),
            buildRoute(INLINE_EDIT_DONATION_URLS.donate, EditDonationPanel),
            buildRoute(INLINE_EDIT_DONATION_URLS.card, PaymentMethodPanel, paymentMethodPanelOptions),
            buildRoute(INLINE_EDIT_DONATION_URLS.thankYou, EditDonationSuccessPanel),
            buildRoute(INLINE_EDIT_DONATION_URLS.cancel, CancelDonationPanel),
            buildRoute(INLINE_EDIT_DONATION_URLS.cancelSuccess, DonationCanceledPanel),
            buildRoute(INLINE_SUBSCRIPTION_URLS.subscriptionsOverview, SubscribePlanPanel),
            buildRoute(INLINE_SUBSCRIPTION_URLS.address, AddressPanel),
            buildRoute(INLINE_SUBSCRIPTION_URLS.paymentDetails, PaymentMethodPanel, paymentMethodPanelOptions),
            buildRoute(INLINE_SUBSCRIPTION_URLS.subscriptionCheckout, SubscribeReviewOrderPanel),
            buildRoute(INLINE_SUBSCRIPTION_URLS.subscribeThankYou, SubscribeThankYouPanel),
            buildRoute(INLINE_SUBSCRIPTION_URLS.subscribeFailed, SubscribeFailedPanel),
            buildRoute(INLINE_EDIT_SUBSCRIPTION_URLS.subscribe, EditSubscriptionPanel),
            buildRoute(INLINE_EDIT_SUBSCRIPTION_URLS.changePlan, SubscribePlanPanel),
            buildRoute(INLINE_EDIT_SUBSCRIPTION_URLS.address, AddressPanel),
            buildRoute(INLINE_EDIT_SUBSCRIPTION_URLS.paymentDetails, PaymentMethodPanel, paymentMethodPanelOptions),
            buildRoute(INLINE_EDIT_SUBSCRIPTION_URLS.cancel, EditSubscriptionCancelPanel),
            buildRoute(INLINE_EDIT_SUBSCRIPTION_URLS.cancelSuccess, EditSubscriptionCancelSuccessPanel),
            buildRoute(INLINE_EDIT_SUBSCRIPTION_URLS.success, EditSubscriptionSuccessPanel),
            buildRoute(INLINE_USER_DASHBOARD_URLS.removeCard, InlineUserDashboardRemoveCardPanel),
            buildRoute(INLINE_USER_DASHBOARD_URLS.cardInUsage, InlineUserDashboardCardInUsagePanel),
            buildRoute(INLINE_USER_DASHBOARD_URLS.addPublicCard, PaymentMethodPanel, paymentMethodPanelOptions),
            buildRoute(INLINE_USER_DASHBOARD_URLS.addAddress, AddressPanel),
            buildRoute(INLINE_USER_DASHBOARD_URLS.editAddress, AddressPanel),
            buildRoute(INLINE_USER_DASHBOARD_URLS.removeAddress, InlineUserDashboardRemoveAddressPanel),
            buildRoute(INLINE_USER_DASHBOARD_URLS.addressInUsage, InlineUserDashboardAddressInUsePanel),
            buildRoute(INLINE_USER_DASHBOARD_URLS.editSubscriptionPaymentMethod, PaymentMethodPanel, paymentMethodPanelOptions),
            buildRoute(INLINE_USER_DASHBOARD_URLS.editSubscriptionAddress, AddressPanel),
            buildRoute(INLINE_USER_DASHBOARD_URLS.editSubscriptionPlan, SubscribePlanPanel),
            buildRoute(INLINE_USER_DASHBOARD_URLS.subscriptionChangeConfirm, InlineUserDashboardSubscriptionChangeConfirmPanel),
            buildRoute(INLINE_USER_DASHBOARD_URLS.subscriptionChangeSuccess, InlineUserDashboardSubscribeChangeSuccessPanel),
            buildRoute(INLINE_USER_DASHBOARD_URLS.changeEmailConfirmationCode, InlineUserDashboardChangeEmailCodeConfirmPanel),
            buildRoute(INLINE_GIFT_SUBSCRIPTION_URLS.subscriptionPlans, SubscribePlanPanel),
            buildRoute(INLINE_GIFT_SUBSCRIPTION_URLS.giftDetails, GiftSubscriptionPlansPanel),
            buildRoute(INLINE_GIFT_SUBSCRIPTION_URLS.paymentDetails, PaymentMethodPanel, paymentMethodPanelOptions),
            buildRoute(INLINE_GIFT_SUBSCRIPTION_URLS.reviewOrder, GiftSubscriptionReviewOrderPanel),
            buildRoute(INLINE_GIFT_SUBSCRIPTION_URLS.success, GiftSubscriptionSuccessPanel),
            buildRoute(INLINE_GIFT_SUBSCRIPTION_URLS.fail, GiftSubscriptionFailedPanel),
            buildRoute(INLINE_GIFT_SUBSCRIPTION_URLS.address, AddressPanel),
        ];
    }

    getRoutes() {
        return new Route([], null, this.getSubroutes(), {});
    }

    setupAuthHelper(page) {
        AuthHelper.addAuthenticationCallback(() => {
            // TODO hack that needs to be reviewed and refactored
            // After authenticating on micro transaction merchants, don't
            // redirect back to PANEL_TYPE.payment, which is actually the authentication panel,
            // instead let the makePayment() logic do its job
            if (page === PANEL_TYPE.payment || page === PANEL_TYPE.donationPage || page === EMPTY_PANEL_TYPE) {
                return;
            }

            Router.changeURL(page);
        });
    }

    preventScrollPropagation() {
        const node = document.documentElement;
        node.setAttribute("tabindex", 0);

        const scrollEventOptions = supportsPassiveEvents() ? {passive: false} : false;

        node.addEventListener("wheel", e => e.stopPropagation(), scrollEventOptions);
        node.addEventListener("touchmove", e => e.stopPropagation(), scrollEventOptions);
    }

    hideScrim() {
        this.redraw();
        Object.assign(document.documentElement.style, {
            background: "transparent",
        });
    }

    showScrim() {
        Object.assign(document.documentElement.style, {
            background: PaywallAppGlobalStyleSheet.getInstance().themeProps.MERCHANT_SCRIM_BACKGROUND,
        });
    }

    initializeFlows() {
        donateMobileState.init(); // TODO: We need this, but not like this.
        subscribeFlowState.init(); // Same as above
        giftSubscriptionFlowState.init();
    }

    onMount() {
        super.onMount();

        addScrimListeners(IFRAME_APP_TYPE.paywall);
        this.preventScrollPropagation();

        const checkPaymentRequestError = () => {
            const {paymentRequestStatus, panelType} = iFrameState;
            if (panelType === PANEL_TYPE.payment && authService.isAuthenticated()
                && paymentRequestStatus?.error?.pgLink) {
                Router.changeURL(paymentRequestStatus.error.pgLink);
            }
        };
        checkPaymentRequestError();

        this.attachUpdateListener(iFrameState, () => {
            this.applyMerchantTheme();
            this.applyMerchantMessages();
            Theme.Global.updateStyleSheets();
            checkPaymentRequestError();
            this.redraw();
        });

        if (iFrameState.gateType === GATE_TYPE.popup && Router.getCurrentPath() !== "/" + EMPTY_PANEL_TYPE) {
            this.showScrim();
        }

        iFrameConnection.addListener(IFrameMessages.ROUTE_CHANGE, ({url}) => {
            this.initializeFlows();
            if (url) {
                Router.changeURL(url);
            } else {
                Router.changeURL(this.getPage());
            }
            // Order matters. We need the router paths to be correct.
            if (url === EMPTY_PANEL_TYPE) {
                this.hideScrim();
            } else if (iFrameState.gateType === GATE_TYPE.popup) {
                this.showScrim();
            }
        });
    }
}
